import { trace } from 'rytm-helpers'
import { scrollToTarget } from './../shared/common'
import { validateGroup } from './../shared/form-validation'

/**
 * #############################
 * ### Form fields iteration ###
 */

const cloneFields = (wrapper, fields, nextIndex) => {
  const copies = getFieldCopies(fields, nextIndex)
  copies.forEach((el) => {
    wrapper.appendChild(el)
  })
}
const getFieldCopies = (fields, nextIndex) => {
  let arr = []
  fields.forEach((el) => {
    let c = el.cloneNode(true)
    let input = c.querySelector("input, select, textarea")
    if (input) {
      input.name += nextIndex
      if (input.value) {
        input.value = ""
      }
      if (input.checked) {
        input.checked = false
      }
    }
    arr.push(c)
  })
  return arr
}
// # Zwraca tablicę z polami do powielenia
const getIteratorFields = (el) => {
  const names = getIteratorFieldNames(el)
  let selector = ''
  names.forEach((name) => {
    selector += (selector ? ", " : "")
    selector += (".formfield-" + name)
  })
  return selector ? [...document.querySelectorAll(selector)] : []
}
// # Zwraca tablicę z nazwami pól input
const getIteratorFieldNames = (el) => {
  let arr = []
  const str = el?.dataset?.fieldNames
  if (str) {
    arr = str.split(",")
  }
  return arr
}
// # Zwraca wrapper do którego powielamy
const getIteratorFielsWrapper = (el) => {
  let wrapper = null
  const selector = el?.dataset?.wrapper
  if (selector) {
    wrapper = document.querySelector(selector)
  }
  return wrapper
}
// # Zwraca indeks kolejnych pól (dodawany do nazwy)
const getIteratorNextIndex = (el) => {
  const ind = el?.dataset?.nextIndex
  return ind ? parseInt(ind) : null
}
/**
 * # Event Listeners #
 */
/**
 * Klik: "Dodaj kierunek" / "Dodaj język"
 */
 const onFormIteratorClick = (e) => {
  e.preventDefault()
  const trigger = e.currentTarget
  const fields = getIteratorFields(trigger)
  const wrapper = getIteratorFielsWrapper(trigger)
  let nextIndex = getIteratorNextIndex(trigger)
  if (wrapper && fields.length) {
    cloneFields(wrapper, fields, nextIndex)
    // update index
    nextIndex++
    trigger.dataset.nextIndex = nextIndex
  }
}


/**
 * ########################
 * ### Prev / NEXT step ###
 */

let currentStep = 0
/**
 * ### RESET ###
 */
export const resetCareerForm = () => {
  setActiveStep(0)
}


// # Uaktualnij status elementu form submit
export const updateFormSubmitState = () => {
  const wrapper = getFormSubmitWrapper()
  if (wrapper) {
    if (isLastStep()) {
      wrapper.classList.add("active")
    } else {
      wrapper.classList.remove("active")
    }
  }
}
// # Czy jestem na ostatnim kroku?
const isLastStep = () => {
  const list = getFormSteps()
  return currentStep >= (list.length - 1)
}
// # Przejdź do kroku
const setActiveStep = (ind) => {
  // grupy pól formularza
  const list = getFormSteps()
  list.forEach((el, index) => {
    if (index == ind) {
      el.classList.add("active")
      scrollToTarget(el, -200)
    } else {
      el.classList.remove("active")
    }
  })
  // nawigacja (sidebar)
  const list2 = getFormStepMenuItems()
  list2.forEach((el, index) => {
    if (index == ind) {
      el.classList.add("active")
    } else {
      el.classList.remove("active")
    }
  })
  currentStep = ind
  updateFormSubmitState()
}
const getFormSteps = () => {
  return [...document.querySelectorAll(".wformfields-list-step")]
}
const getFormActiveStep = () => {
  return document.querySelector(".wformfields-list-step.active")
}
const getFormStepMenuItems = () => {
  return [...document.querySelectorAll(".wformfields-list-li")]
}
const getFormSubmitWrapper = () => {
  return document.querySelector(".formfield-submit")
}
/**
 * # Event Listeners #
 */
// # Prev step click
const onFormPrevStepClick = (e) => {
  e.preventDefault()
  setActiveStep(currentStep - 1)
}
// # Prev step click
const onFormNextStepClick = (e) => {
  e.preventDefault()
  if (validateGroup(getFormActiveStep())) {
    setActiveStep(currentStep + 1)
  }
}

/**
 * ### INIT ###
 */
export const initCareerForm = () => {
  resetCareerForm()
  // form prev / next step
  $("body").on("click", ".step-prev", onFormPrevStepClick)
  $("body").on("click", ".step-next", onFormNextStepClick)
  // form iterator
  $("body").on("click", ".wformiterator-btn", onFormIteratorClick)
}